import { Outlet, useNavigate } from 'react-router-dom';
import { useState, useLayoutEffect, useRef } from 'react';
import { AppTopBar } from './AppTopBar';
import { AppSidebar } from './AppSidebar';
import { LoadingIndicator } from './LoadingIndicator';
import { useUserSessionContext } from '../hooks/contexts/useUserSessionContext';
import { useUserInformationFetch } from '../hooks/useUserInformationFetch';

export const AppPrivateLayout = () => {
  const navigate = useNavigate();
  const { isReady, userSession, login } = useUserSessionContext();
  const { data, isError, isFetching } = useUserInformationFetch(!!userSession);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const didTriggerLogin = useRef(false);

  const shouldRequireLogin = isReady && !userSession;
  const hasNoRoles = !!data && !(data.roles ?? []).length;

  useLayoutEffect(() => {
    if (isError) {
      sessionStorage.clear();
      localStorage.clear();
    }
    if (shouldRequireLogin && !didTriggerLogin.current) {
      didTriggerLogin.current = true;
      login();
    }
    if (hasNoRoles) {
      navigate('/unauthorized');
    }
  }, [isError, shouldRequireLogin, login, hasNoRoles, navigate]);

  if (!userSession || !data || isFetching) {
    return <LoadingIndicator isFullScreen />;
  }

  if (hasNoRoles) {
    return <LoadingIndicator isFullScreen />;
  }

  return (
    <div className="app-shell">
      <AppTopBar onToggleSidebar={() => setSidebarOpen((prev) => !prev)} />
      <div className="app-body">
        <AppSidebar isOpen={sidebarOpen} />
        <main className="app-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
};
